"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var timer_1 = require("ayvri-std/lib/timer");
var React = require("react");
var react_1 = require("react");
var avatar_1 = require("../avatar");
var styles_1 = require("./styles");
exports.UserMenu = function (props) {
    var name = props.name, avatarUrl = props.avatarUrl, arrowUrl = props.arrowUrl, profileUrl = props.profileUrl, children = props.children;
    var _a = react_1.useState(false), open = _a[0], setOpen = _a[1];
    var menuRef = react_1.useRef(null);
    react_1.useEffect(function () {
        var menu = menuRef.current;
        if (!menu) {
            return undefined;
        }
        var timer;
        var handleMouseEnter = function () { return timer_1.clearTimeout(timer); };
        var handleMouseLeave = function () {
            timer = timer_1.setTimeout(function () { return setOpen(false); }, 500);
        };
        menu.addEventListener('mouseenter', handleMouseEnter);
        menu.addEventListener('mouseleave', handleMouseLeave);
        return function () {
            menu.removeEventListener('mouseenter', handleMouseEnter);
            menu.removeEventListener('mouseleave', handleMouseLeave);
        };
    }, [menuRef.current]);
    return (React.createElement("div", { className: styles_1.styles.container },
        React.createElement("div", { className: styles_1.styles.userDetails },
            React.createElement("a", { className: styles_1.styles.profileLink, href: profileUrl },
                React.createElement(avatar_1.Avatar, { name: name, imageUrl: avatarUrl, hideBorder: true }),
                React.createElement("div", { className: styles_1.styles.userName }, name)),
            React.createElement("img", { className: styles_1.styles.arrow, src: arrowUrl, onClick: function () { return setOpen(!open); } })),
        React.createElement("div", { ref: menuRef, className: styles_1.styles.menu, style: { visibility: open ? 'visible' : 'hidden' } }, children)));
};
exports.UserMenu.displayName = 'UserMenu';
